import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanDeactivate,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable } from 'rxjs';
import { TextsForWebPageComponent } from '../pages/cms/texts-for-web/texts-for-web-page.component';
import { FormChangedGuard } from './form-changed-guard/form-changed-guard';

@Injectable({
  providedIn: 'root',
})
export class WebTextsFormChangedGuard
  extends FormChangedGuard
  implements CanDeactivate<TextsForWebPageComponent>
{
  canDeactivate(
    component: TextsForWebPageComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.handleNavigation(component.hasChanges, nextState.url);
  }
}
